<template>
  <div class="container college">
    <div class="header card">
      <el-breadcrumb class="breadcrumb"
                     separator="/">
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
        <el-breadcrumb-item>订单管理</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">订单管理</h2>
        </div>
        <div class="right">
          <el-button class="button"
                     type="primary"
                     @click="handleOrderCreate">创建订单</el-button>
          <el-button icon="el-icon-upload2"
                     @click="handleBatchShipping">批量发货</el-button>
          <el-button icon="el-icon-download"
                     @click="handleExport">导出</el-button>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query">
        <el-form-item label="订单号"
                      prop="order_no">
          <el-input v-model.trim="query.order_no"
                    placeholder="输入订单编号/交易单号"
                    @input="searchSetTimeout()"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品名称"
                      prop="goods_name">
          <el-input v-model.trim="query.goods_name"
                    placeholder="输入商品名称"
                    @input="searchSetTimeout()"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="商品ID"
                      prop="ref_ids">
          <el-select v-model="query.ref_ids"
                     multiple
                     filterable
                     allow-create
                     default-first-option
                     collapse-tags
                     clearable
                     placeholder="输入商品ID"
                     style="width: 200px"
                     @change="fetchOrderList(true)">
          </el-select>
        </el-form-item>
        <el-form-item label="商品类型"
                      prop="ref_type">
          <el-select v-model="query.ref_type"
                     multiple
                     collapse-tags
                     clearable
                     placeholder="请选择"
                     style="width: 150px"
                     @change="fetchOrderList(true)">
            <el-option v-for="item in filter.refTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用户昵称"
                      prop="user">
          <el-input v-model.trim="query.user"
                    placeholder="输入用户昵称/姓名/手机号"
                    clearable
                    @input="searchSetTimeout()"></el-input>
        </el-form-item>
        <el-form-item label="支付类型"
                      prop="pay_type">
          <el-select v-model="query.pay_type"
                     multiple
                     collapse-tags
                     placeholder="请选择"
                     clearable
                     @change="fetchOrderList(true)">
            <el-option v-for="item in filter.payTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单类型"
                      prop="pay_type">
          <el-select v-model="query.order_types"
                     placeholder="请选择"
                     clearable
                     multiple
                     collapse-tags
                     @change="fetchOrderList(true)">
            <el-option v-for="item in filter.orderTypes"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态"
                      prop="status">
          <el-select v-model="query.status"
                     multiple
                     collapse-tags
                     placeholder="请选择"
                     clearable
                     @change="fetchOrderList(true)">
            <el-option v-for="item in filter.status"
                       :key="item.value"
                       :label="item.label"
                       :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker class="datetime"
                          v-model="createDatetime"
                          type="datetimerange"
                          range-separator="至"
                          start-placeholder="开始日期"
                          end-placeholder="结束日期"
                          clearable
                          @change="timechange"
                          :default-time="['00:00:00', '23:59:59']">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="推荐人"
                      prop="category_id">
          <el-autocomplete class="inline-input"
                           v-model="admin_referrer"
                           :fetch-suggestions="querySearch"
                           placeholder="请输入内容"
                           :trigger-on-focus="false"
                           @select="handleSelect"
                           clearable
                           @clear="handleAutoClear"></el-autocomplete>
        </el-form-item>
        <el-form-item label="渠道邀请人"
                      prop="crm_inviter_user_keyword">
          <el-input v-model.trim="query.crm_inviter_user_keyword"
                    placeholder="请输入机构简称/昵称/手机号"
                    clearable
                    @input="searchSetTimeout()"></el-input>
        </el-form-item>
      </el-form>
      <!--       <div class="divider"></div>
      <div class="action-wrap">
        <el-button type="primary" @click="handleSearch">搜索</el-button>
        <el-button @click="handleFormReset('searchForm')">重置</el-button>
        <el-button icon="el-icon-download" @click="handleExport"
          >导出</el-button
        >
      </div> -->
    </div>
    <div class="results card">
      <div class="values-header">
        <p class="title">查找结果</p>
      </div>
      <div class="values">
        <el-table class="table"
                  :data="results"
                  border
                  style="width: 100%">
          <el-table-column prop="id"
                           label="ID"
                           width="80"
                           align="center">
          </el-table-column>
          <el-table-column prop="order_no"
                           label="订单编号"
                           min-width="160"
                           align="center">
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品名称"
                           width="300"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.ref_type==7">{{formatJointProduct(scope.row)}}</span>
              <span v-else>{{scope.row.goods_name}}</span>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name"
                           label="商品类型"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <span>{{ formatRef_type(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户信息"
                           width="200"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              <span v-if="scope.row.user">{{
                `${scope.row.user.nickname}${
                  scope.row.user.realname ? `/${scope.row.user.realname}` : ""
                }`
              }}</span>
            </template>
          </el-table-column>
          <!--      <el-table-column label="用户手机号" width="120" align="center">
            <template slot-scope="scope">
              <span>{{  
                scope.row.user ? `${scope.row.user.mobile}` : ""
              }}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="total_amount"
                           label="订单金额"
                           min-width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.total_amount }}元</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间"
                           width="160"
                           align="center">
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付方式"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span v-if="scope.row.pay_type==0">-</span>
              <span v-else-if="scope.row.pay_type==1">支付宝</span>
              <span v-else-if="scope.row.pay_type==2">微信</span>
              <span v-else-if="scope.row.pay_type==3">系统</span>
              <span v-else-if="scope.row.pay_type==4">
                <span v-if="scope.row.hb_fq_seller_percent==100">
                  花呗分期(免{{scope.row.hb_fq_num}}期)
                </span>
                <span v-else>花呗分期</span>
              </span>
              <span v-else-if="scope.row.pay_type==5">研币</span>
            </template>
          </el-table-column>
          <el-table-column label="订单类型"
                           width="150"
                           align="center">
            <template slot-scope="scope">
              <span>{{ typeformate(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="订单状态"
                           width="120"
                           align="center">
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="推荐人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formateAdmin_referrer(scope.row.admin_referrer)}}
            </template>
          </el-table-column>
          <el-table-column label="渠道邀请人（新）"
                           min-width="160"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ formatOrderCrmInviter(scope.row) }}
            </template>
          </el-table-column>
          <el-table-column prop="name"
                           width="120"
                           label="渠道邀请人"
                           align="center"
                           show-overflow-tooltip>
            <template slot-scope="scope">
              {{ scope.row.user.ref_admin_inviter_nickname ?scope.row.user.ref_admin_inviter_nickname :'无'}}
            </template>
          </el-table-column>
          <el-table-column label="操作"
                           width="120"
                           align="center"
                           fixed="right"
                           v-if="isfixed">
            <template slot-scope="scope">
              <el-button size="mini"
                         type="text"
                         @click="handleToOrderInfo(scope.row, scope.$index)">详情</el-button>
              <el-button v-if="scope.row.pay_status === 0 && scope.row.status === 0"
                         size="mini"
                         type="text"
                         @click="handlePriceChange(scope.row, scope.$index)">改价</el-button>
              <el-button v-if="
                  scope.row.receiver_address &&
                  ![0,1,5].includes(scope.row.status)
                "
                         size="mini"
                         type="text"
                         @click="handleToExpressInfo(scope.row, scope.$index)">{{[2].includes(scope.row.status)?'发货':'物流'}}</el-button>
            </template>
          </el-table-column>
          <el-table-column label=""
                           width="40"
                           align="center"
                           fixed="right"
                           v-else>
            <template slot-scope="scope">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  ...
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"><span @click="handleToOrderInfo(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      详情
                    </span></el-dropdown-item>
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"
                                    v-if="scope.row.pay_status === 0"><span @click="handlePriceChange(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      改价
                    </span></el-dropdown-item>
                  <el-dropdown-item command="a"
                                    style="margin-bottom:6px;"
                                    v-if="
                  scope.row.receiver_address &&
                  ![0,1,5].includes(scope.row.status)
                "><span @click="handleToExpressInfo(scope.row, scope.$index)"
                          style="font-size:16px;color: #409EFF;">
                      {{[2].includes(scope.row.status)?'发货':'物流'}}
                    </span></el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination background
                       layout="total, prev, pager, next, sizes, jumper"
                       :current-page="Number(query.pageIndex)"
                       :page-sizes="[10, 20, 50, 100, 500]"
                       :page-size="Number(query.pageSize)"
                       :total="Number(pageTotal)"
                       @size-change="handleSizeChange"
                       @current-change="handlePageChange"></el-pagination>
      </div>
    </div>
    <OrderDetail :id="orderId"
                 :visible="orderDetailDiglog"
                 :userContent="userContent"
                 @close="orderDetailDiglog = false"></OrderDetail>
    <ExpressDetail :content="orderItem"
                   :visible="expressDetailDiglog"
                   @close="expressDetailDiglog = false"
                   @submit="fetchOrderList"></ExpressDetail>
    <BatchShipping :visible="batchShippingDialog"
                   @close="batchShippingDialog = false"
                   @completed="handleBatchShippingCompleted"></BatchShipping>
  </div>
</template>

<script>
import OrderDetail from '@/components/dialog/order/OrderDetail'
import ExpressDetail from '@/components/dialog/order/ExpressDetail'
import BatchShipping from '@/components/dialog/order/BatchShipping'
import {
  memberOrderList,
  memberOrderUpdate,
  memberOrderExport,
} from '@/api/member'

let Timer = null // 定时器
let TimerTime = 1000 // 定时器 等待时长

export default {
  components: {
    OrderDetail,
    ExpressDetail,
    BatchShipping,
  },
  data() {
    return {
      orderDetailDiglog: false,
      expressDetailDiglog: false,
      batchShippingDialog: false,
      editRow: {},
      query: {
        status: '',
        pay_type: '',
        pageIndex: 1,
        pageSize: localStorage.getItem('pageSize')
          ? Number(localStorage.getItem('pageSize'))
          : 10,
        isPaging: 1,
        ref_type: '',
        order_types: '',
        admin_referrer: '',
        crm_inviter_user_keyword: '',
        ref_ids: '',
      },
      admin_referrer: '',
      createDatetime: '',
      pageTotal: 10,
      filter: {
        status: [
          { label: '待支付', value: '0' },
          { label: '已支付', value: '1' },
          { label: '待发货', value: '2' },
          { label: '待收货', value: '3' },
          { label: '已完成', value: '4' },
          { label: '已取消', value: '5' },
        ],
        payTypes: [
          { label: '支付宝', value: '1' },
          { label: '微信', value: '2' },
          { label: '系统', value: '3' },
          { label: '花呗分期', value: '4' },
          { label: '研币', value: '5' },
        ],
        refTypes: [
          { label: '课程', value: '1' },
          { label: '题库', value: '2' },
          { label: '专栏', value: '3' },
          { label: '资料', value: '4' },
          { label: '文章', value: '5' },
          { label: '学长', value: '6' },
          { label: '联报', value: '7' },
          { label: '组合购', value: '8' },
        ],
        orderTypes: [
          { label: '普通订单', value: '0' },
          { label: '拼团订单', value: '1' },
          { label: '优惠订单', value: '2' },
        ],
      },
      results: [],
      orderItem: {},
      orderId: null,
      isfixed: document.body.clientWidth < 820 ? false : true,
      userContent: {},
    }
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf()
        this.query.endTime = this.$moment(value[1]).valueOf()
      } else {
        this.query.startTime = ''
        this.query.endTime = ''
      }
    },
  },
  created() {
    this.parseQuery()
    this.fetchOrderList()
    this.$store.dispatch('getAdminList')
  },
  methods: {
    // 订单列表请求
    fetchOrderList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.status) {
        params.status = params.status.filter((v) => v).join(',')
      }
      if (params.pay_type) {
        params.pay_type = params.pay_type.filter((v) => v).join(',')
      }
      if (params.ref_type) {
        params.ref_type = params.ref_type.filter((v) => v).join(',')
      }
      if (params.order_types) {
        params.order_types = params.order_types.filter((v) => v).join(',')
      }
      if (params.ref_ids) {
        params.ref_ids = params.ref_ids.filter((v) => v).join(',')
      }
      memberOrderList(params).then((res) => {
        // console.log('res:', res)

        this.results = res.list || []
        this.pageTotal = res.count
      })
      this.syncQuery()
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchOrderList(true)
      }, TimerTime)
    },
    // 用户数据导了同
    handleExport() {
      const params = Object.assign({}, this.query)
      if (params.status) {
        params.status = params.status.filter((v) => v).join(',')
      }
      if (params.pay_type) {
        params.pay_type = params.pay_type.filter((v) => v).join(',')
      }
      if (params.ref_type) {
        params.ref_type = params.ref_type.filter((v) => v).join(',')
      }
      if (params.order_types) {
        params.order_types = params.order_types.filter((v) => v).join(',')
      }
      if (params.ref_ids) {
        params.ref_ids = params.ref_ids.filter((v) => v).join(',')
      }
      memberOrderExport(params).then((res) => {
        if (res) {
          window.open(res.url)
        }
      })
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, 'pageSize', val)
      localStorage.setItem('pageSize', val)
      this.fetchOrderList()
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, 'pageIndex', val)
      this.fetchOrderList()
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, 'pageIndex', 1)
      this.fetchOrderList()
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields()
      // 手动处理
      this.createDatetime = null
      this.fetchOrderList()
    },
    // 订单状态渲染
    statusRender(row) {
      const order_status = {
        0: '待支付',
        1: '已支付',
        2: '待发货',
        3: '待收货',
        4: '已完成',
        5: '已取消',
      }
      const pay_status = {
        0: '待支付',
        1: '已支付',
        2: '已取消',
      }
      const audit_status = {
        0: '待审核',
        1: '审核通过',
        2: '审核未通过',
      }
      const refund_status = {
        0: '未申请',
        1: '退款中',
        2: '已退款',
      }
      return order_status[row.status] || ''
    },
    // 订单创建
    handleOrderCreate() {
      this.$router.push(`/order/create`)
    },
    // 批量发货
    handleBatchShipping() {
      this.batchShippingDialog = true
    },
    handleBatchShippingCompleted() {
      this.fetchOrderList()
    },
    // 订单详情
    handleToOrderInfo(row) {
      this.userContent = JSON.parse(JSON.stringify(row)).user
      this.orderId = row.id
      this.orderDetailDiglog = true
    },
    // 物流信息
    handleToExpressInfo(row) {
      this.orderItem = row
      this.expressDetailDiglog = true
    },
    // 订单改价
    handlePriceChange(row) {
      this.$prompt('请输入新的订单金额', '订单改价', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        inputPattern: /^[0-9]+.{0,1}[0-9]{0,2}$/,
        inputErrorMessage: '请输入正确的数值',
      })
        .then(({ value }) => {
          memberOrderUpdate({ id: row.id, total_amount: Number(value) }).then(
            (res) => {
              this.$message.success(`订单金额修改成功`)
              this.fetchOrderList()
            }
          )
        })
        .catch(() => {})
    },
    // 订单删除
    handleToTeacherRemove(row) {
      // 二次确认删除
      this.$confirm('确定要删除吗？', '提示', {
        type: 'warning',
      })
        .then(() => {
          teacherDestroy({ id: row.id }).then((res) => {
            this.$message.success(`删除成功`)
            this.fetchOrderList()
          })
        })
        .catch(() => {})
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.status) {
        this.query.status = this.query.status.split(',')
      }
      if (this.query.pay_type) {
        this.query.pay_type = this.query.pay_type.split(',')
      }
      if (this.query.ref_type) {
        this.query.ref_type = this.query.ref_type.split(',')
      }
      if (this.query.order_types) {
        this.query.order_types = this.query.order_types.split(',')
      }
      if (this.query.ref_ids) {
        this.query.ref_ids = this.query.ref_ids.split(',')
      }
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ]
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      if (params.status) {
        params.status = params.status.filter((v) => v).join(',')
      }
      if (params.pay_type) {
        params.pay_type = params.pay_type.filter((v) => v).join(',')
      }
      if (params.ref_type) {
        params.ref_type = params.ref_type.filter((v) => v).join(',')
      }
      if (params.order_types) {
        params.order_types = params.order_types.filter((v) => v).join(',')
      }
      if (params.ref_ids) {
        params.ref_ids = params.ref_ids.filter((v) => v).join(',')
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    typeformate(row) {
      let arr = []
      if (row.user_coupon_id) {
        arr.push('优惠订单')
      } else if (row.activity_id) {
        arr.push('拼团订单')
      } else {
        return '普通订单'
      }
      return arr.join('/')
    },
    formatRef_type(row) {
      const obj = {
        0: '无',
        1: '课程',
        2: '题库',
        3: '专栏',
        4: '资料',
        5: '文章',
        6: '学长',
        7: '联报',
      }
      return obj[row.ref_type] || ''
    },
    timechange(e) {
      if (e == null) {
        this.query.startTime = ''
        this.query.endTime = ''
      }
      this.fetchOrderList(true)
    },
    formatJointProduct(row) {
      if (row.multi_ref_list.length) {
        let str = row.multi_ref_list
          .map((v) => {
            return v.goods_name
          })
          .join(',')
        return str
      } else {
        return '无'
      }
    },
    formateAdmin_referrer(val) {
      if (this.$store.state.adminList.length) {
        if (val) {
          let obj = this.$store.state.adminList.find((v) => {
            return v.id == val
          })
          if (obj) {
            return obj.nickname
          }
          return '无'
          // return this.$store.state.adminList.find((v) => { return v.id == val }).nickname
        } else {
          return '无'
        }
      }
    },
    querySearch(queryString, cb) {
      var restaurants = this.$store.state.adminList.map((v) => {
        return {
          value: v.nickname,
          id: v.id,
        }
      })
      var results = queryString
        ? restaurants.filter(this.createFilter(queryString))
        : restaurants
      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (
          restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) ===
          0
        )
      }
    },
    handleSelect(item) {
      this.query.admin_referrer = item.id
      this.fetchOrderList(true)
    },
    handleAutoClear() {
      this.query.admin_referrer = ''
      this.fetchOrderList(true)
    },
    // 渠道邀请人（新）：机构名/昵称/手机号 有值以 / 拼接，三项全空显示 --
    formatOrderCrmInviter(row) {
      const obj = row.order_crm_inviter_obj || {}
      const parts = [
        obj.company_name,
        obj.company_user_alias,
        obj.company_user_phone,
      ].filter(
        (v) => v !== null && v !== undefined && String(v).trim() !== ''
      )
      return parts.length ? parts.join('/') : '--'
    },
  },
}
</script>

<style scoped lang="less">
.college {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
      overflow-y: visible;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .avatar {
      display: block;
      width: 68px;
      height: 68px;
      object-fit: cover;
      margin: 0 auto;
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
</style>
